
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.36 5.934L10.018.344a1.675 1.675 0 00-2.036 0L.64 5.934c-.402.307-.638.78-.64 1.28V17.37c0 .432.175.847.486 1.152.31.306.732.478 1.172.478h14.684c.44 0 .861-.172 1.173-.477.31-.306.485-.721.485-1.153V7.215a1.621 1.621 0 00-.64-1.281z","fill":"#B5B8B5"}}),_c('path',{attrs:{"d":"M10.066 10.475a2.573 2.573 0 001.473-1.719 2.529 2.529 0 00-.472-2.2 2.621 2.621 0 00-2.054-.986c-.803 0-1.56.364-2.055.987a2.529 2.529 0 00-.472 2.2c.195.765.739 1.4 1.473 1.718a3.544 3.544 0 00-2.113 1.168 3.438 3.438 0 00-.848 2.233v1.84c0 .247.1.484.278.659a.956.956 0 00.67.273h6.11a.956.956 0 00.67-.273.923.923 0 00.278-.66v-1.84a3.437 3.437 0 00-.84-2.225 3.546 3.546 0 00-2.098-1.175z","fill":"#fff"}})])
          )
        }
      }
    